import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const weightRulesAdapter = getAdapter({ idFieldName: 'id' });

const weightRulesSlice = createSlice({
  name: 'weightRules',
  initialState: weightRulesAdapter.getInitialState(),
  reducers: {
    setWeightRules: (state, { payload: { weightRules } }) => {
      weightRulesAdapter.setAll(state, weightRules);
    },
  },
});

const selectors = weightRulesAdapter.getSelectors(({ weightRules }) => weightRules);

export const getWeightRules = (state) => selectors.selectAll(state);

export const { setWeightRules } = weightRulesSlice.actions;
export default weightRulesSlice.reducer;
